import store from '../state/store';
const config = store.getters['auth/config'];

export const menuItems = [
    {
        label: "Anasayfa",
        icon: "bxs-dashboard",
        link: "/",
        roles: ["site", "finance", "root", "site_finance", "iban_control", "site_report", "personal"],
        active: "1"
    },
    {
        label: "Banka Yönetimi",
        icon: "bxs-bank",
        roles: ["root", "finance", "iban_control", "personal"],
        active: "1",
        subItems: [
            {
                label: "Bankalar",
                link: "/banks",
                roles: ["root", "finance", "personal"],
            },
            {
                label: "Banka Hesapları",
                link: "/bank-accounts",
                roles: ["root", "finance", "iban_control", "personal"],

            }
        ]
    }, {
        label: "İşlemler",
        icon: "bx-transfer",
        roles: ["site", "finance", "root", "site_finance", "iban_control", "site_report", "personal"],
        active: "1",
        subItems: [
            {
                label: "Para Yatırma",
                link: "/deposits",
                roles: ["site", "finance", "root", "site_finance", "iban_control", "site_report", "personal"],
            },
            {
                label: "Para Çekme",
                link: "/withdrawals",
                roles: ["site", "finance", "root", "site_finance", "iban_control", "site_report", "personal"],
            }
        ]
    },{
        label: "Kara Liste",
        icon: "bx bx-error",
        link: "/blacklist",
        roles: ["root", "personal"],
        active: "1"
    },{
        label: "Email Servisi",
        icon: "bx bx-mail-send",
        link: "/pool",
        roles: ["finance", "root", "personal"],
        active: config.emailService ? "1": false
    }, {
        label: "Site Yönetimi",
        icon: "bx bx-list-ul",
        link: "/sites",
        roles: ["root", "personal"],
        active: "1"
    },{
        label: "Kullanıcı Yönetimi",
        icon: "bx bx-user",
        link: "/users",
        roles: ["root", "personal"],
        active: "1"
    }, {
        label: "Kasa Yönetimi",
        icon: "bx bx-money",
        roles: ["root", "site", "report", "site_report", "personal"],
        link: "/payments",
        active: config.balanceSystem ? "1": false
    }, {
        label: "Raporlar",
        icon: "bxs-report",
        roles: ["site", "finance", "root", "personal", "report", "site_report"],
        link: "/reports",
        active: "1"
    }
];

